// @ts-nocheck
export default {
  CUSTOMER_DEPOSITS_TABLE_STATE_SET: 'CUSTOMER_DEPOSITS/TABLE_STATE_SET',
  CUSTOMER_DEPOSITS_TABLE_STATE_RESET: 'CUSTOMER_DEPOSITS/TABLE_STATE_RESET',
};
